import React, {Component, Fragment } from 'react';
import FeesPro from '../../../images/driverpolicy-images/PRO Gas Fees@2x.png';
import CreditsPro from '../../../images/driverpolicy-images/PRO Gas Credits@2x.png';
import FeesPlus from '../../../images/driverpolicy-images/PLUS Gas Fees@2x.png';
import CreditsPlus from '../../../images/driverpolicy-images/PLUS Gas Credits@2x.png';
import FeesGo from '../../../images/driverpolicy-images/GO Gas Fees@2x.png';
import CreditsGo from '../../../images/driverpolicy-images/GO Gas Credits@2x.png';
import gaslevel from '../../../images/driverpolicy-images/Gas Level.png';

class GasShortages extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
  	const { city } = this.props;
    
    return(

	    <Fragment>
	    <span id='gaslevel' className='anchor2'></span>
	    <div className='gas__content--container'>
            <span className='damages__title--container'>
              <img src={gaslevel}/>
              <h3><strong>Gas Shortages</strong></h3>
            </span>
            <br/>
         	<div className='gas__intro--container'> 
		    <p>
		      All cars should have a full tank of gas upon pickup and dropoff.
		    </p>
		    <p>
		      If not, take a photo showing the gas gauge is not full and make an incident report through the Autzu Dashboard.
		    </p>
		    <p>
		      The previous driver who failed to refill gas is charged a fee, and the driver impacted is given credit to refill the gas which includes an added amount for the inconvenience.
		    </p>
		    </div>
		    <br/>
		    {city === 'new_york' ? (
		    <div>
		     <p><strong>GO Gas Credits / Fees</strong></p>
		      <div className='fees-credits'>
				  <br/>
				  <figure>
				    <img className="fuel-image" src={CreditsGo} alt="" />
				    <p>We Pay (Reimburse)</p>
				  </figure>
				  <br/>
				  <figure>
				    <img className="fuel-image" src={FeesGo} alt="Fuel Pro" />
				    <p>We Charge (Deduct)</p>
				  </figure>
				  <br/>
		     </div>
		    </div>):(
		    <div>
		    <p><strong>PRO Gas Credits / Fees</strong></p>
			    <div className='fees-credits'>  
				    <br/>
				   <figure>
				    <img className="fuel-image" src={CreditsPro} alt="" />
				    <p>We Pay (Reimburse)</p>
				   </figure>
				   <br/>
				   <figure>
				    <img className="fuel-image" src={FeesPro} alt="Fuel Pro" />
				    <p>We Charge (Deduct)</p>
				   </figure>
				   <br/>
			    </div>
		    </div>)}
		    <br/>
		    {city === 'new_york' ? null:(
		    <div>
		     <p><strong>PLUS Gas Credits / Fees</strong></p>
			     <div className='fees-credits'>
				    <br/>
				   <figure>
				    <img className="fuel-image" src={CreditsPlus} alt="" />
				    <p>We Pay (Reimburse)</p>
				   </figure>
				   <br/>
				   <figure>
				    <img className="fuel-image" src={FeesPlus} alt="" />
				    <p>We Charge (Deduct)</p>
				   </figure>
				   <br/>
			    </div>
		    </div>)}
		    <br/>
		</div>
	    </Fragment>
    )
  }
 }

export default GasShortages;


// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/GasShortages.js